import React, { Component } from 'react';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';

import MediaTypePanel from './MediaTypePanel';
import DateRangePanel from './DateRangePanel';
import SourcePanel from './SourcePanel';
import KeywordPanel from './KeywordPanel';

import { Scrollbars } from 'react-custom-scrollbars';

const container = connect(
  createSelector(
    (state) => ({
      pathname: _.get(state, 'router.location.pathname'),
    }),
    (state) => {
      const routes = state.pathname.split('/')[4];
      return ({
        routes
      })
    }
  )
)

import './style.css';

class ControlPanel extends Component {

  render() {
    const {routes,disabledSource} = this.props;
    const noShowSource = ['sample', 'testing', 'recycle']
    return (
      <div className="panel">
        <div>
          <MediaTypePanel />
          <div>
            <DateRangePanel />
            <KeywordPanel />
            {_.findIndex(noShowSource, (m) => {return m == routes}) == -1 &&
              <SourcePanel disabledSource={disabledSource}/>
            }
          </div>

        </div>
      </div>
    )
  }
}

export default container(ControlPanel)



/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/components/ControlPanel.js
 **/